import React from 'react';
import { Button } from '@radix-ui/themes';
import { useNavigate } from 'react-router-dom';
import useLanguage from '../../contexts/language/LanguageContext';
import { LoaderSvg } from '../../styles/icons/LoaderSvg';

type Props = {
  backText?: string,
  backUrl?: boolean | string,
  continueText?: string,
  showLoaderInContinueBtn?: boolean,
  onBack?: () => void,
  onContinue?: () => void
  disabledBackBtn?: boolean,
  disabledContinueBtn?: boolean,
}

export const Footer = (props: Props): React.ReactElement => {
  const navigate = useNavigate()
  const language = useLanguage();

  const onClickBack = () => {
    if (props.onBack) {
      props.onBack()
      return
    }

    if (!props.backUrl) {
      return
    }

    if(typeof props.backUrl === 'string') {
      navigate(props.backUrl)
      return;
    }

    navigate(-1)
  }

  return (
    <div className={`flex items-center w-full mt-10 ${!props.backUrl ? 'justify-end' : 'justify-between'}`}>
      {
        props.backUrl
          ? <Button variant="surface" size="4" onClick={onClickBack} disabled={props.disabledBackBtn}>
            { props.backText ? props.backText : language.translations.general.back }
          </Button>
          : <></>
      }

      {
        props.onContinue
          ? <Button variant="solid" size="4" onClick={props.onContinue} disabled={props.disabledContinueBtn}>
            {props.showLoaderInContinueBtn && (
              <LoaderSvg fill="white" />
            )}
            {props.continueText ? props.continueText : language.translations.general.continue }
          </Button>
          : <></>
      }
    </div>
  )
}
